import SectionHeader from './SectionHeader';
import { INDUSTRIES } from '../config/site';

export default function IndustriesSection() {
  return (
    <section className="section industries-section">
      <div className="container">
        <SectionHeader
          creative
          light
          align="center"
          label="Industries"
          title="Built for operators who run real infrastructure"
          description="Our platforms serve teams managing devices, networks, and consumer services at production scale."
        />
        <div className="industries-grid">
          {INDUSTRIES.map((industry, index) => (
            <article key={industry.id} className="industry-card">
              <span className="industry-card__index">{String(index + 1).padStart(2, '0')}</span>
              <h3>{industry.title}</h3>
              <p>{industry.description}</p>
              {industry.product && (
                <span className="industry-card__product">{industry.product}</span>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
